
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'backspaceKey': `⟵`,
'clearKey': `⎚ Tiszta`,
'deleteKey': `⌦ Törlés`,
'downKey': `↓ Lefelé`,
'endKey': `⤓ Vége`,
'enterKey': `Írja be a címet.`,
'escapeKey': `⎋ Menekülés`,
'f10Key': `F10`,
'f11Key': `F11`,
'f12Key': `F12`,
'f13Key': `F13`,
'f14Key': `F14`,
'f15Key': `F15`,
'f16Key': `F16`,
'f17Key': `F17`,
'f18Key': `F18`,
'f19Key': `F19`,
'f1Key': `F1`,
'f2Key': `F2`,
'f3Key': `F3`,
'f4Key': `F4`,
'f5Key': `F5`,
'f6Key': `F6`,
'f7Key': `F7`,
'f8Key': `F8`,
'f9Key': `F9`,
'h64cd12550420f6f1': html`Generáljon egy 
          <code>LICENSE 
          </code> fájlt 
        `,
'homeKey': `⤒ Főoldal`,
'keyCommand': `⌘ Command/Win`,
'keyControl': `^ Ellenőrzés`,
'keyOption': `⌥ Opció/Alt`,
'keyShift': `⇧ Shift`,
'leftKey': `← Balra`,
'pagedownKey': `▼ Pagedown`,
'pageupKey': `▲ Pageup`,
'rightKey': `→ Jobbra`,
's00065e45db8c0441': `További részletekért lásd a fejlesztői eszközöket`,
's001dd78415a91fa0': `Gördítősáv eresz`,
's002fa7d1054ed082': `Határoló doboz`,
's006f872a5b7f5279': `Sangro`,
's01b16a926920908b': `Kazahsztán`,
's01b56d233c6c5cac': `Szekcionálás`,
's01d32b35baa3b676': `Szerző`,
's02106cc2ef0e7578': `Új tű...`,
's02ab1ea8e5100fc1': `Jelölje meg a kiválasztást "kétirányú felülbírálásként".`,
's0312976fe9da5951': `Gomb`,
's03608a32f05eded2': `Csípő zoom`,
's036d35e03be98d22': `Matematikai mélység`,
's037b1dc850a89273': `Alternatív alatt`,
's0396202b716732ec': `Jelölje meg a kiválasztást átütöttként`,
's03f49e598ffb11cc': `Lengyel`,
's0448f1059fa01720': `Mentsd el, oszd meg vagy nyomtasd ki a felfedezhető anyagot. Szerkesztheti az olyan információkat, mint a cím, a nyelv vagy a licenc.`,
's0458872c43beadef': `Sor beszúrása a következő előtt`,
's04c939a414fdab21': `Tsonga`,
's050954cd4ae83304': `Szóközök`,
's05e9759cfd99c48f': `Igazolja a  címet.`,
's063fa5a0a4903bf4': `Oldalirányban, balról jobbra`,
's064339c229374050': `Kódolás`,
's06634274f19b0572': `Pin kiválasztás`,
's06743b24499f0035': `Horgonyzó központ`,
's07808b0ca6da8fef': `Bekerített weboldal`,
's07970793b21351fd': `Ruby alaptartály`,
's079cf7850d9327f0': `Betűtípus`,
's07aa10850d9ddcc7': `Formanyomtatvány`,
's07e6118e838b2e23': `Navigáció`,
's0816468df86e4036': `Megnyitja a beállításokat`,
's082869038c117fe5': `Portugál (Brazília)`,
's086e6c267ade2609': `Telítettség`,
's08e12ade32ef8125': `Setswana`,
's08e6bd98452e6bb9': `Audio`,
's0978fb5ba3145996': `Lista beszúrása (rendezetlen)`,
's09c3f1d21de14ae1': `Jelölje a kiválasztást aláhúzottként`,
's0a2d91c6720033e9': `Szövegközök vágása`,
's0a3ddcba94027d95': `Tárgy illeszkedés`,
's0a6cb8d42cdb0c4a': `Eszperantó`,
's0a799f583098cadf': `Navigáció beillesztése`,
's0a7db790db1fc45c': `Jelölje meg a kijelölést span-ként`,
's0b1271f50a77dc73': `Tartalom doboz`,
's0b24d08ea349b455': `Minden, amit be tudsz illeszteni. Az elején a nem interaktív elemek, mint a listák vagy képek, majd az interaktív elemek, az úgynevezett widgetek következnek. Újakat a keresősávra kattintva szerezhetsz be.`,
's0bdca49248ba4820': `Rövidítések`,
's0befccf152b6c0a9': `Orient a metaadatokból`,
's0c11e479416c8421': `Táblázatfelirat beillesztése`,
's0c27336067c59611': `Görgetés kitöltés`,
's0c4593d81f147042': `Alapvonal`,
's0c4b2e98d4ab7f5a': `Alkalmazás parancsok`,
's0c883713b83616a8': `Az aktív dokumentum mentése`,
's0ca5c0460199cba1': `Rövidítés`,
's0cf10c4f40588f8d': `Tábla felirat`,
's0d86afa3c6a1e28b': `Flex irány`,
's0dad143dff0079fc': `Malayalam`,
's0db05bd7ba6fff96': `Az Ön feltárható dokumentuma. Ide írhatsz szöveget és másolhatsz/beilleszthetsz, szerkeszthetsz stb.`,
's0dc452999c129e15': `Élő újratöltés engedélyezése`,
's0de0febab8a4beaf': `Hiba a csomag olvasásában`,
's0e44968489e076a8': `Kínai`,
's0e4862e87c7d53ce': `Jelölje meg a kiválasztást idézetként`,
's0e6ea8870dbddab2': `Dokumentum parancsok`,
's0ee28503778e4c0c': `Utolsó alapérték`,
's0ef01c03299bbb83': `Dekoráció`,
's0f17f32919661cff': `Mongol`,
's0f350bc4e538e3ea': `Szavak`,
's105a06836c40fcb4': `A kiválasztott elemek szűrőinek, színének és keverésének beállítása`,
's106b274b5af798e5': `Mondatok`,
's1082e1649793dca9': `Jelölje meg a kiválasztást meghatározott kifejezésként`,
's10f3845975a0351e': `Metaadatok szerkesztése`,
's1125d159f7e64df5': `Megjelenítés`,
's11326fd2590f4e5e': `Alapértelmezett`,
's1155ec07a221e739': `Gördítősáv`,
's1173bf7a3e0b74c9': `Minimum (y)`,
's1177237a3e0e548c': `Minimum (x)`,
's1219d97b49650c05': `Láthatóság`,
's123bea44f38abccf': `Objektum beillesztése`,
's1245e2cb9f20197e': `Align`,
's12946ec1b850962c': `Oszlop beillesztése után`,
's1351209ef74ee729': `Az összes oszlop felölelése`,
's13c60cb409e8cb6f': `Középre igazítás`,
's13ebd619c8a06a6d': `Rács automatikus sorok`,
's13ef8ca26ca8861b': `Vágott elem`,
's151bc2eea7a032a4': `-unchanged-`,
's153bc3c3aa39587b': `Asztalfő`,
's156647179b21d351': `Táblázattest beszúrása`,
's158b6ec6b1fffcb2': `Szünet után`,
's15d0c0657c1ee08c': `API kulcs`,
's1626a7e10a9f9dcc': `A kijelölés betűtípuscsaládjának beállítása`,
's1637c7d1a30629e2': `Border Box`,
's1641ab440bf4daa4': `A widget csomag frissítése`,
's166bd56d19670a72': `Nagyítás`,
's1696c76a23c0834e': `Haladó: 0.x.x.x verziójú csomagok megjelenítése a csomagkezelőben`,
's16b9446e3a70e1f4': `Attribútumok`,
's16f205466761e583': `Nincs optikai betűméretezés`,
's16f2f1c2c516d307': `Dokumentum megnyitása`,
's1749014f3f87fa6a': `Stretch`,
's17597a8bb4810524': `Licenc`,
's17bfaaa4e7528bc7': `Baskír`,
's17fb3f4805f4f4b9': `Mező eltávolítása`,
's181ef198cf83ec3a': `Bihari`,
's1857db526dc4dcdd': `Csomag létrehozása`,
's18d5c44aae3dc82a': `Online szerkesztés közben`,
's1988d71ef8060edf': `Táblázatsor beszúrása`,
's19abee1277c9bca2': `Szamoai`,
's19daf2f26c19543d': `Vázlat`,
's1a1acc902e6668e0': `Speciális szövegformázás megjelenítése`,
's1a5230a71d9285c1': `Capture`,
's1aa1cb63ad44bc6f': `Oszlop hézag`,
's1af8b67d1c85c811': `Közötti tér`,
's1b4a36fce2456660': `Betűcsalád`,
's1c246045629b0016': `A kiválasztás törlésként való megjelölése`,
's1c3fc313a9184670': `Nyilvános kapcsolat`,
's1c65f5004a07dcfa': `Skót gael nyelv`,
's1c690963f1e2df00': `Platform-specifikus megjelenés`,
's1ca22ce85e074da5': `Pragma`,
's1d10d2058d8ca8dd': `Rövid, vezetett túrát szeretne?`,
's1d19244f549ec535': `Oktatás`,
's1d5c7b28e8b50d6d': `Associate deg.`,
's1db591f5a54dbfd3': `Tartalom doboz`,
's1dbb9f50e16c92a3': `Határ sugara`,
's1dfb744260fb3a01': `Kétirányú elszigetelés`,
's1e9c2c654732cc5f': `Fehéroroszország`,
's1eaccbf2d6af8ab5': `Információ`,
's1efbfc3937d565bd': `Háttér`,
's1f2b49c1bca2035d': `Katalán`,
's1f74bdf32b51a5fc': `Háttérkép`,
's1f7698c061c208c9': `Nyissa meg a címet.`,
's1f8e59d0624842ff': `Kannada`,
's1feab14d837eadb0': `Guarani`,
's20deffeecf2699fb': `Korzikai`,
's21d61916eb8d137d': `Asztali test`,
's21d723a1dbcd89c8': `Jávai`,
's21f8a2eaf5a70749': `Címke beillesztése`,
's2206c42e5b835e6e': `Jelölje meg a kiválasztást rövidítésként`,
's22a2348c46a912a0': `Szakasz beillesztése`,
's233ae776268cd44b': `Üzleti`,
's236ed7ba747099b0': `Betűsúly`,
's2474e7fb1aec9f05': `Teszt`,
's2492f5fb1b05b45e': `Szöveg`,
's24949d7adbb5a098': `Szerszámosláda`,
's252a52330d32b900': `Metaadatok`,
's2540844a4bc4d9ba': `Megköveteli a hozzárendelést?`,
's255857544a9d5ec0': `Reset`,
's255c77900f2b5e0f': `Színösszeállítás`,
's256ab831a48c941c': `Eltávolít minden szövegformázást a kijelölésből.`,
's2591806d7b222591': `Módosítások visszaállítása`,
's25e1a07e454c2c11': `Rács`,
's262abbaf1d05f009': `Lágy fény`,
's266935f2447fcd98': `Balra át`,
's268ecd1cef45a9a8': `Biztos vagy benne?`,
's2692bc028fed91f1': `⇪ Caps Lock`,
's27056379e0acfdb0': `Lighten`,
's27076e66c5d483ba': `Függőleges igazítás`,
's2712dc5641a33226': `A csomagregiszterfiókok fejlesztők számára készültek, és lehetővé teszik egy vagy
          több regiszter konfigurálását.`,
's27cc88818cc46ff6': `Stabil`,
's281d957112b10f12': `A dokumentum HTML-jének közvetlen szerkesztése`,
's28b6246ce616a548': `Táblázat oszlopcsoport beszúrása`,
's29a1c26521879b9f': `Méretezés lefelé`,
's29acfd2778e8c377': `Speciális szövegformázás elrejtése`,
's29b24c06315e9343': `Bemenet beszúrása`,
's29eb103449472e3b': `Cím beillesztése (3. szint)`,
's29ee7434494a0dfe': `Cím beillesztése (2. szint)`,
's29f21c34494d614d': `Cím beillesztése (1. szint)`,
's29fbfc3449557f72': `Cím beillesztése (6. szint)`,
's29ff743449588131': `Cím beillesztése (5. szint)`,
's2a031834495bcdb4': `Cím beillesztése (4. szint)`,
's2a75c946ef4dcab7': `Egyéb`,
's2b2ae20d26f78ac2': `Blokk`,
's2b8f50c64be440f7': str`Válassza ki a címet. 
          ${0}... 
        `,
's2ba5f4d8f3bd7c57': `Megrendelés`,
's2bad2d24def4aa0b': `Zárójelváltás (CJK lang.)`,
's2ceb11be2290bb1b': `Törölje`,
's2ced8e8fafb499f6': `Elem törlése`,
's2d986d31f8d67357': `Mezőkészlet beszúrása`,
's2d995a37cf5e4995': `NoScript beillesztése`,
's2de969afacdaa7a6': `Shape`,
's2df075aface0dab8': `Megosztás`,
's2e192b19ed15fcf6': `Oldal`,
's2e39b99cf23606fa': `A kiválasztott elemek elrendezésének beállítása`,
's2e4818861000b13f': `Elrendezés`,
's2e66bf8b833858f3': `Uigur`,
's2e969a451b4955d1': `Marathi`,
's2eda5288a65bca1d': `Túlcsordulás (y)`,
's2edd6688a65e21f0': `Túlcsordulás (x)`,
's2f0bcdffc92a786b': `Úszás jobbra`,
's2f2044f2431a32d5': `Cím:`,
's2f4d4bfbc466d91f': `Albán`,
's2f8da2cb5f236588': `A csomag neve. Legyen meghatárolt, például \`@org/pkg\`. `,
's30cce87854901922': `Óvoda`,
's3124653c272f054c': `Oszlop szabály színe`,
's314a4f7685c8e824': `Mindig`,
's31c06e226322f065': `Kerülje az árvákat`,
's323dcde72b850272': `Nyilvános hozzáférés`,
's32911e52ee8ac745': `Helyezze be a nyílást`,
's337a1e9022a8d19f': `Asztal`,
's33c1450d2822bb0f': `Ábrafelirat beillesztése`,
's33c18d5a4cbffa2a': `Ír`,
's33f85f24c0f5f008': `Mentés`,
's342b0cabfa672822': `Segítsen a felhasználónak megtalálni a widgetet`,
's3437e0d9899e7ae1': `Telemetriai adatok küldése a WebWriter használatáról.`,
's344ea8f4939cdc98': `Színes`,
's34dcda3b0f9d5a98': `Átkapcsolás url`,
's34f724979a124c50': `A kiválasztott szöveg háttérszínének beállítása`,
's355b21b89ce5d9c5': `Részletek`,
's35ae5f4e0fa2777b': `Egyéni igazítás`,
's35aeaff1425bca9e': `A WebWriter nem támogatja a `,
's35c3125c7750681e': `Blockquote`,
's3643189d1abbb7f4': `Kód:`,
's3649bacefe731bf6': `Eszköztár kapcsoló`,
's365280e16a8ea32d': `A kijelölés másolása`,
's366991b9c9287765': `Jobbra`,
's36a194e38d653a26': `Adatok megjegyzése`,
's36b3cefdcb897f15': `Perspektíva`,
's372fae706048ce41': `Páros-páratlan`,
's377e24af9628c37e': `Rendezett lista`,
's37a8c35f6581da5f': `Nincs horgony`,
's37fa3b9cd51c2dfd': `A kijelölés betűméretének beállítása`,
's380d17664bb69531': `Szúrja be az oszlopot a`,
's3815184eb09f0dcf': `Cursor`,
's382a2aa3984474dd': `Hozzon létre`,
's38980f98cb07ceb8': `Az aktív dokumentum másolatként történő mentése`,
's3914cb410fca44d4': `Import`,
's3a179f6db2972384': `Ruby pozíció`,
's3a5ca02f282d247e': `Megosztás...`,
's3ae67088bbefba98': `Csomagok`,
's3b0ab4b52326316f': `Fény`,
's3b3ea038c5d3bb06': `Részleg`,
's3bdad99768e11911': `Felfedezhető`,
's3cb47df8290fa94c': `Opció beillesztése`,
's3cf89cb47fdde7e9': `Link`,
's3d09398e555ee5f9': `Speciális beállítások`,
's3d249bb480032121': `Lista`,
's3d3efd1e19bdcfb4': `Dátum/idő megjegyzés`,
's3d6a732c792ccb9e': `Ruby megjegyzés`,
's3d93f9ea0c5a13fa': `Kép`,
's3d9548e211b958ce': `Átfedések kihagyása`,
's3e092e9d1ee2c5bb': `Clip`,
's3e78ddc9a48a608d': `Szép`,
's3eb6d1e6e79ed7c4': `Nem találtak dokumentumokat`,
's3eca5a034978754b': `A kiválasztás törlése`,
's3f06e9abb6ebcb79': `Karakterek`,
's3f1e7a3f2b283d3b': `Margin`,
's3f299e83cbf52fba': `Zhuang`,
's3f43ef2eaa1ec486': `Gujarati`,
's3f7e097a9b2e6181': `Cikk beillesztése`,
's3fd83566dd643d10': `Legenda beillesztése`,
's3fe72792941c18f9': `Szöveg alul`,
's3ffcdc5db5e7d0c5': `Fordított`,
's40e3826b7f74a3b5': `Pan (jobbra)`,
's40f07d7859284a44': `Domináns alapvonal`,
's4101ada154a1b958': `Középső`,
's410c465a5993f82d': `Vonaltörési lehetőség`,
's41322d19c928c603': `ICT`,
's417b90913e05bc17': `Előnézet`,
's418f2020fe996832': `Változások megerősítése`,
's41c724f0698148e9': `A kijelölés billentyűparancsként való megjelölése`,
's41f65a763f8e44ab': `Asztalfejléc csoport`,
's42721130228841b0': `Stroke box`,
's429bd646f1cf8bc6': `A Grammar LLM fiókok lehetővé teszik a Grammar LLM API használatát a szöveg nyelvtani javítására.`,
's429dd933ba95549b': `Cím beillesztése`,
's42e470ef1d707a28': `Autoplay`,
's42ffdab1291fb3de': `Sor beszúrása a következő után`,
's430831017f3f0499': `Ferdeség (y)`,
's430bd5017f42511c': `Ferdeség (x)`,
's433ba70286202ceb': `Break all`,
's441b20a8a50e36b4': `Macedóniai`,
's445b8acb9206db6e': `Elvetés és törlés`,
's446a924922651ea0': `Szövegkiemelés`,
's44cdba92713de38e': `Rácsterület`,
's45518abd911471d0': `Horvát`,
's456a8d744313852a': `Tér körül`,
's4634541f5056a546': `Abházia`,
's46d4abe6255cb9e1': `Rövid parancsikon újbóli hozzárendelése`,
's4730c232e7209c40': `Mindkettőt vágja le`,
's474f0eec369d02a4': `Minta kimenet`,
's47a8f6dfb38b9701': `Telugu`,
's47e257ae643b5851': `A kijelölés dátum/idő megjegyzésként való megjelölése`,
's47ebf3a8fb3b10c1': `Orientáció`,
's4802bb8eb52fbdeb': `Portál`,
's4802e47fe2e95134': `Opció`,
's491d2919cd6ec3d9': `Hue`,
's497838412cb455f2': `Szövegárnyék`,
's4993444bfd3f3e5e': `Összeomlás`,
's49ad24935b14e3df': `Quechua`,
's49c560aecfeb8c29': `Maszk`,
's49dd67aed00029ef': `Matematika`,
's49e763aed00877a8': `Főoldal`,
's4a894f57eba1cf1e': `Billentyűzet parancsikon`,
's4ac1ad6ecd6bd810': `Misc. ed.`,
's4ad6e9d3c2365c98': `Kemény fény`,
's4b2c143acf931122': `Vonalmagasság`,
's4b58c01e2578f5e4': `Legenda`,
's4bbff4e008690da1': `Kerülje az oldalt`,
's4c1535f316305a2a': `Ellenőrizze a kiválasztást`,
's4c402ff5355fd310': `Kétirányú felülbírálás`,
's4caed5b7a7e5d89b': `Angol`,
's4cb38675a21b2c98': `Nem támogatott tulajdonságtípus '\${desc.type}' (JSON-ként történő feldolgozás)`,
's4cc8391f172c0cdf': `Túra befejezése`,
's4d528b416ac8dee2': `Címcsoport beillesztése`,
's4d546f6c87128d5b': `Először a világűr`,
's4dcb9315f6527f9c': `Futtatás újratöltéskor`,
's4e191bdb4700a6e9': `Overscroll (x)`,
's4e1c7fdb470386ac': `Overscroll (y)`,
's4e2562fe3990e621': `Csatlakozási hiba`,
's4e361bf8eef3759a': `Szószünet`,
's4ea0f21fc2a338a1': `Mozogj feljebb`,
's4eace13b3ed74187': `Oldal megjegyzés`,
's4efee5b48a4593cb': `Hurok`,
's4f26e7cb7c0a8318': `Vektoros rajzolás`,
's4fd2e638aabb0bb3': `A WebWriter számos különböző forrás beágyazását támogatja. Egyszerűen illessze be a
          tartalomra mutató linket a következőkből:`,
's4fda04cbc245e18b': `Alpha`,
's4ffac3fb33a2ee9b': `Thai`,
's5015a8fb33b98872': `Vékony`,
's50489ffb1bde152e': `Beillesztés`,
's5068560b8d39663d': `Kattintható térkép`,
's517acbf1f96324f9': `Súly`,
's523eb9043213ff0d': `Italic`,
's52777d434baeed9b': `Haladásjelző beillesztése`,
's52af5d7ac34c2163': `Táblázat sor`,
's52e0bdc3ee304436': `Mérőeszköz behelyezése`,
's531056f039febd39': `Szúrjon be egy kijelölést`,
's536695196d0b6dc3': `Feröer`,
's542fcefa0bbaed86': `Az eszköztár megnyitása vagy bezárása (csak keskeny képernyőkön, egyébként az eszköztár mindig látható az oldalon).`,
's5432ad3c84273229': `Ábra`,
's543906d1db8b2283': `Szerkesztés `,
's543c237e8c895ce8': `Bislama`,
's545ee1f373f249cf': `Kambodzsai`,
's54897f2764b0e4d0': `Telepítse ezt a widget csomagot`,
's54cbfaf2a8da7818': `Pashto`,
's550839f3e4e205bb': `Jelölje meg a kiválasztást kiemelten fontosnak`,
's55905c735052d295': `Tematikus szünet`,
's5590dbf7e425789d': `Címke`,
's5623aa2f83b05c76': `Tibeti`,
's564d1648b1ceee9f': `Naprakész`,
's565cd5ffb0158c46': `Kerülje a régiót`,
's571a4f19e2f140c7': `Pan (x)`,
's571db319e2f4208a': `Pan (y)`,
's575e795c45e2d97e': `Menj vissza`,
's5787c6d5b3b5541a': `Clip útvonal`,
's579c69f419b6caef': `Sima`,
's587ac858dd80f6fa': `Felirat:`,
's58bec0ecd4f3ccd4': `Szigorú`,
's59404f5593c32fdc': `Font kerning`,
's5941292bb77281ab': `Norvég Bokmål`,
's599dcd2472c75c19': `bekezdés`,
's59b20e8af32606ed': `Afar`,
's5a1a0898baf20675': `Jelölje meg a kijelölést egy adatmegjelöléssel`,
's5a356677b61a6b7e': `Moldáviai`,
's5b474b5c0ac0c7c4': `Táblázat oszlopcsoport`,
's5b517ac216f9ee62': `Oldalirányban`,
's5b8cc9bb61ddce15': `Egy bekezdés beillesztése`,
's5bba2ac2e53bd1fd': `Kirgiz`,
's5be80ad6b8301710': `Inline indítás`,
's5c1ecf88259b79f9': `Bemutatkozás`,
's5c2a1a52c0389c30': `Mérnöki tevékenység`,
's5c63af7695445fcf': `Szöveg stílus`,
's5d18ca4c3111be6f': `Táblázatfej beillesztése`,
's5d87c1e588f48d90': `Gyakorlat`,
's5d929ff1619ac0c9': `Keresés`,
's5da52af9b083c29a': `Modell`,
's5dc77784260a7236': `auto`,
's5e27738a2e8eb763': `Bejelentkezés`,
's5e2cba97c0d971bd': `Csomagok újratöltése`,
's5e53415a6d5719ad': `Társadalomtudományok`,
's5e6a7a0c30d2a270': `Átfedések kihagyása (automatikus)`,
's5e9e8e4d21bafedc': `Élelmiszer-termelés`,
's5ed03bb1f3a15949': `Kép`,
's5f43af3669b1e098': `Forrás`,
's5feaf7fd7ee567c8': `Szünet szó`,
's600fd23c9ce971e8': `Az aktív dokumentum nyomtatása`,
's602bbd28dae2c60f': `Önindítás`,
's60ff598dfcf2c773': `Jobbra alatt`,
's61053f0e3ebbd272': `normál`,
's613c6ff83883c04f': `Tábla oszlop`,
's6196153c4b0c1ea0': `Telepítse a`,
's61c017f6d5c303af': `Fríz`,
's61ded17ca3f48c82': `Aláhúzás eltolás`,
's61eacb19db252f5e': `URL`,
's621ad19d35ba7742': `Másolás kiválasztás`,
's624e31cd4f1b89d4': `Sima görgetés`,
's626daf42b1ab7df7': `Balra igazítás`,
's6280bf993915c57a': `Görgetési margó`,
's62b857f5b6693742': `Inupiak`,
's63d894b1ddb06289': `Leírás`,
's63dfc5b1c1c27849': `Jiddis`,
's63e03c70f67ebf9c': `Kontextus`,
's63e71d20d1eaca93': `Német`,
's640bc7710d0143ce': `Az aktív dokumentumban az utolsó visszavonatlan módosítás újbóli elvégzése`,
's64dc1fc7e3db45c9': `Új dokumentum létrehozása`,
's65ac276544ba33cd': `SVG fájl`,
's66765c420ee578e4': `Tér egyenletesen`,
's669b18c6d2d9c95b': `Nincs`,
's6747dbf4ad6063ba': `Self end`,
's6787497df07fa97e': `Megállók felett görgethet`,
's67c2b60a506a09e4': `Középiskolai kiadás.`,
's680bd4d926cd5a84': `3D megőrzése`,
's6827930ef1aeaf99': `Bázis URL`,
's684a16f3c711394d': `Over Right`,
's687e27f036a71b32': `Izolálni`,
's68b87d7b61052dc3': `Táblázatsor`,
's68e0e3a2bab7ce3e': `Kerülje a`,
's690da6b432987c6f': `Automatikusan biztonsági másolatokat készít az aktuális dokumentumban. A változtatások a WebWriter újratöltésekor visszaállnak.`,
's69311c4e25074fb3': `Középiskola`,
's697400b541fbc3cd': `A  címen.`,
's6988ab5d47593a26': `Ön a WebWriter legújabb verziójával rendelkezik.`,
's69a49786a8009f43': `Csomagok keresése...`,
's69b12144dbb6544d': `Laothian`,
's69d88ef4b2618980': `Borító`,
's69fbbdb8ad2a084a': `Darken`,
's6a31eff1ec4f71ad': `Hátlap elrejtése (3D)`,
's6ac62e1c8c66f3bb': `Kompakt superscr.`,
's6b585ba37cdb8260': `Örökölni`,
's6b61f8abf89586be': `Héber`,
's6bd7a02fdf93e653': `A tartalom összehangolása`,
's6cfc66b824ea05ba': `Ropogós élek`,
's6d02dc19e21eb49c': `Top`,
's6d1df519e235a6cf': `Twi`,
's6d60d595cb5070da': `Vietnámi`,
's6d8b3b8047ed378d': `Mix blend üzemmód`,
's6d8c02aee480af7a': `Menü`,
's6dadeaaee49d6d18': `Meta`,
's6dfb502188a8c7c2': `Stílus beillesztése`,
's6e288a119281f4c2': `Szöveges megjelenítés`,
's6e4c20c6debcd5ca': `Egyéni igazolás`,
's6f84199e62584905': `Előformázott szöveg`,
's6fb3053e7244d326': `Egyéb területek`,
's70178e04a3b691b6': `Beállítások megnyitása`,
's7031ca562378bde6': `Geometriai pontosság`,
's7060970b5ed20a58': `Interaktivitás`,
's7136449045eff28c': `Tamil`,
's71940c32987f675f': `WebWriter Cloud`,
's71a0549fd71219c9': `Instabil csomagok megjelenítése`,
's71dec51005acc1e4': `Sűrű sor`,
's72f2a02e2a5a4ee3': `Média`,
's730182ad28374cda': `Objektum`,
's731678e227a20559': `Ez a készülék`,
's736904f276fbd441': `Természettudományok`,
's739544d0c858c633': str`Vagy ejtsd 
          ${0} itt 
        `,
's73cb20c838e761e1': `Vágás kiválasztása`,
's7417792bbe720149': `Redo`,
's741fae02b3dd24f3': `Pixelált`,
's743f778233e42a3f': `Függelék beillesztése`,
's744d993d03f29851': `Képernyő`,
's748c0074eff45884': `Manipuláció`,
's74aa0039a87141e2': `Ellipszis`,
's74b9781bacfcc87c': `Pandzsábi`,
's74cd20a7aece9b91': `Töltse ki a mezőt`,
's75109f5307578a61': `Üdvözöljük a WebWriter`,
's75a27f43413e02c5': `Francia`,
's75d83fc3f0cfab40': `Fejléc`,
's762e5704cc84089d': `A kiválasztott elemek egyéb stílusbeállításainak beállítása`,
's77318393dfdb0775': `Sor eltávolítása`,
's77e594ddcc10c774': `Engedélyezi a kereskedelmi célú felhasználást?`,
's782eac2b3e80323d': `Jelölje meg a kiválasztást hangsúlyozottként`,
's782f286a79cca35d': `Relatív`,
's78673a3539cb1915': `Balra fent`,
's78789724e789221c': `Méret`,
's789ff24c8f03f1a4': `Betűtávolság`,
's7995733bf97c01cc': `Szerb-horvát`,
's7a99528e7b64635a': `Occitan`,
's7aaf0c06e69600f1': `Hiba a `,
's7ae49e142487766c': `Közösségi hozzáférés`,
's7af555180b30a947': `Nyissa meg a fejlesztői eszközöket`,
's7b4ba250601b8667': `Sablon beillesztése`,
's7b560d8693ed8f42': `Felegyenesedve`,
's7b9994904c4f5b54': `Tádzsik`,
's7bdf0fd5b014d36c': `Erős fontosság`,
's7beb1e77e82363eb': `Az aktív dokumentum legutóbbi módosításának visszavonása`,
's7c61118554a0ec36': `Maximális (x)`,
's7c95876637f6a9d7': `Szűrő`,
's7cb4e55c59663b1c': `Cég`,
's7cfe12cd14df9950': `Kijelentkezés`,
's7d27db3c9639c6dd': `Alternatív`,
's7d8103f6f06f83d6': `Padding`,
's7d864465dddbb50d': `Méretváltás engedélyezése`,
's7de0e28d6c309a4e': `Érintéses műveletek engedélyezése`,
's7dea785045c3cc74': `Nyomja meg az új billentyűkombinációt...`,
's7e0b179d4d1414eb': `Adja meg a linket`,
's7e6570f2f1ae320f': `Betűtípusok szintetizálása`,
's7ecb1f29332293e5': `Az igazítás alapvonala`,
's7ed13ccddb1bf3c3': `Overlay`,
's7edbe0b213199995': `Bachelor`,
's7ede1c55e35ce9d6': `Szimuláció`,
's7f09197a4814079b': `Interaktivitási opciók beállítása a kiválasztott elemekhez`,
's7f326a142e856656': `Stílus`,
's7fcb35d23be1e643': `Mezőkészlet`,
's80570196a9ce6d11': `Telemetria engedélyezése`,
's806f84eb0ace116e': `Nézze meg, hogy mit választott ki, és változtassa meg. Másolás, kivágás, beillesztés, kitűzés, vagy elrendezési módosítások. Különböző lehetőségeket kínál a kijelöléstől függően, pl. a szöveg formázása.`,
's80a42b81c52d4d8f': `Caret szín`,
's80b71fc6f43c5ce1': `Laza`,
's812cbda653daaeba': `Ez a funkció még nincs megvalósítva`,
's814d528c8af55807': `Definíció listaelem`,
's81c3d8809658b951': `Kasmiri`,
's81cf65c5a46dea08': `Kinyarwanda`,
's81ecf2d4386b8e84': `Folytatás`,
's8247d32213e35f24': `Egy fő beillesztése`,
's82665b2ffabc9c0a': `Honlap`,
's828b1ecea8715884': `Pan (balra)`,
's833bd0422a7ef95d': `Tab mérete`,
's83420ad7b6a14db5': `Toggle Dev Tools (Fejlesztői eszközök)`,
's83c15613b6f6f3c8': `Csak online`,
's83cd32b685ccc9b7': `Vezérlők`,
's83f26d02dd7aa681': `Látható`,
's840fa49e8989c028': `Pozíció/alak`,
's844a76d1843ceb3c': `Alapértelmezettre visszaállítása`,
's84e4e8ae645b82ac': `Jobbra fent (y)`,
's84e9c7f8785ca60b': `Formanyomtatvány beillesztése`,
's8517ae4da104b004': `Táblázat oszlopcsoport`,
's85186a61e0d55bac': `Videó`,
's851a7deea5984646': `Creative Commons OER licenc?`,
's85f9aa6d3ea0e421': `A táblázat lábléc csoportja`,
's864b0e6270e97246': `Jelölje meg a kiválasztást mellékes megjegyzésként`,
's8670e5ad3bf0dcf8': `Mentés másként`,
's8688d74dd3716d6e': `A parancsok billentyűzet gyorsbillentyűi`,
's86ca34c5287a2f38': `Wolof`,
's86f820d8007d0de4': `Alakítási margó`,
's87cefc710b3567fb': `Tartalmazza a  címet.`,
's88676f992b2965db': `A cellák tartalmának nyújtása`,
's886897f2fd4edb99': `Rejtett`,
's886c5db2a5579873': `Koncepció`,
's888c71e8fcb916d3': `Automatikus mentés`,
's88a62d29529948fb': `Táblázat beillesztése`,
's89950d86c8004d4b': `Átfedések kihagyása`,
's89bca7498f20e041': `Háttér klip`,
's8a28bad9290d4761': `Oromo`,
's8a29cb39a42f83f3': `Szünet előtt`,
's8a4ff2bd9c13498c': `Rekord`,
's8a6585c48ea104e9': `Üres cellák elrejtése`,
's8a9eb438abac7c6a': `Címkék`,
's8b0432eecbd8b034': `Frissítés`,
's8b7580c35e2aef87': `Balra fent (y)`,
's8bc4affa761aa8a2': `Kép beszúrása`,
's8c7f51cb067644c7': `Adatok listája`,
's8d342ecaa9e75b9b': `Kapcsolat`,
's8d797888455f4147': `Szüneti terek`,
's8d83386457e91813': `Visszavonhatja/visszacsinálhatja a változtatásokat, vagy megtekintheti az előnézetet a tanuló szemszögéből.`,
's8d8643013a7754d1': `Szöveg igazítása`,
's8df30fe2a50d3479': `Zárójel beillesztése lehetőség`,
's8e715248c3a78446': `Vágja ki a kiválasztást`,
's8f29e48d6b9a1aa8': `Táblázatfejléc sor beszúrása`,
's8f4be9f086eb530f': `Undo`,
's8f533296a536965e': `Mentés másként...`,
's8fad58c831ecf017': `Ruby szövegkonténer`,
's8ffe7abcbed8eb43': `Függőleges, balról jobbra`,
's90105521fcc40453': `A WebWriter Cloud fiókok lehetővé teszik a dokumentumok online tárolását és
          megosztását a diákokkal. Adjon hozzá itt egy fiókot, és az elérhető lesz a dokumentumok
          mentésének, betöltésének, megosztásának és megnyitásának helyeként.`,
's9095f01a80a91594': `Super`,
's90f0fbc12e1e2b2f': `Betűkészlet paletta`,
's90f7c1cf501ea0a7': `Színes kitérő`,
's91093e0b087911ba': `Kiemelt pozíció`,
's919e1724f589c9b1': `Slot`,
's91c5ed7769d00b65': `Beágyazás beillesztése`,
's9219acd5bef6269e': `Bal alatt`,
's92548405912d46bf': `Görgetés snap igazítás (y)`,
's9258280591309342': `Görgetés snap igazítás (x)`,
's927d796559f49439': `Háttér Eredet`,
's92b177e579ef7b97': `Kiemelés`,
's92f846b9be2e8e8d': `A kiválasztás dőlt betűs jelölése`,
's93566b84230af4f5': `Kép beillesztése`,
's936aa0b239679585': `Tematikus szünet beillesztése (általában vízszintes vonalként jelenik meg)`,
's9370dc6afa716b57': `Határ`,
's93f083e654a45715': `Breton`,
's94653c76b2d86a04': `Meghatározott kifejezés`,
's9485af2e7cd9418f': `Általános iskola`,
's94d2eee44b292567': `Speciális beállítások váltása`,
's94d61907ee22a8c1': `Koreai`,
's94eb1effbbb6498b': `Túlcsordulás`,
's951aa3a6439f1271': `Listajelző`,
's9565553d163fc92a': `Forgatókönyv`,
's957787fc6b7ea5c0': `Pan (fel)`,
's95c161f68e5180a5': `Vizsgálja meg a kiválasztást`,
's95d56e58f816d211': `Holland`,
's95d8e41a64635c7c': `Fehér tér`,
's95de7e1eff6c053e': `Vízszintes, fentről lefelé`,
's960d3a90ac199368': `Rhaeto-Román`,
's96532132a29dd542': `Hang beillesztése`,
's96a045dcade75ad0': `Oszlop sűrű`,
's9781a5bb3fcb26a3': `Először válasszon ki egy vállalatot`,
's978522fbc9577a7e': `Szomáliai`,
's97881699a2b21d5b': `Soros rés`,
's97aa76056a81bd36': `Mérőszámok`,
's986facb3ecc9602c': `Oldalirányban, jobbról balra`,
's987abd19fac8cf55': `Sub`,
's9896529e5cb20558': `Külső fájl`,
's98977a87d1b93941': `Információk, stílusok és szkriptek visszaállítása`,
's990d0e0fa2ab00b5': `Galíciai`,
's99229574e5692f19': `Grönlandi`,
's99a990f3841ad283': `Fájlok a `,
's99b38e000175cc84': `Áthúzás`,
's99f110d27e30b289': `Cím`,
's9ab10fbf4c7a7322': `Aláhúzás pozíciója`,
's9abadcc828884d7b': `Textarea`,
's9b7cd8860c8fc922': str`
          ${0}
          felülírásra kerül. Biztos vagy benne? 
        `,
's9c11f2d9335d8bd1': `Oriya`,
's9c356016f81585f6': `Háttérszín`,
's9c8df9626d152d5a': `Meghatározás lista kifejezés`,
's9ca757effd747da9': `Urdu`,
's9caf10388ab3562f': `Táblázat oszlop`,
's9cf68f87b8e6122f': `Azerbajdzsán`,
's9d167ef77aed79b6': `Réteg`,
's9d2d00982edafabb': `Török`,
's9d430adc5be110e9': `Fordított sor`,
's9d54829be67943d3': `Interlingue`,
's9d54869be6794a9f': `Interlingua`,
's9d668a34af4128ff': `Törlés`,
's9df571714a1efb44': `Ennek a felfedezhetőnek egy automatikusan mentett változata is elérhető. Betölteni?`,
's9e28faa598332e2b': `Videó beillesztése`,
's9e3dbb678150edd4': `Betűtípus család beállítása`,
's9e40e59654c8ad67': `Oszlop`,
's9e85800d3700e31c': `Pálya`,
's9e8d3665edde89a6': `Nauru`,
's9eefe6e57e4e1661': `Betűtípus-változat`,
's9f1ecdb3061d9cbc': `Terek megőrzése`,
's9faf26107ed49fb9': `Táblázati cella beszúrása`,
's9fbe26cfd7845469': `Hausa`,
's9fc686f7bbd941e2': `Átmenet`,
's9ff3121d30f88d52': `Normál`,
's9ffe1bbe64712bf1': `Vászon`,
'sa00df4e39c72d3b4': str`
          ${0} nem támogatott 
        `,
'sa013e119fec906fb': `Sor`,
'sa01e7bf33563ef72': `Háttérmelléklet`,
'sa126cf8c627cec1e': `Kép renderelés`,
'sa13f72278add7513': `A jobb oldalon`,
'sa1647e3b36ec08d7': `Kombináljuk függőlegesen`,
'sa172190ea21f9b1c': `Lépjen be a beállításokba, nyisson meg egy felfedezhetőt, vagy hozzon létre egy újat.`,
'sa1c6c459b9b5115c': `Abszolút`,
'sa2cba871f6cdd99f': `Assamese`,
'sa2eff4dad1c119f1': `Rács sablon`,
'sa30c12014e955946': `Orosz`,
'sa30f1981fd1cd441': `Betűméret`,
'sa311a24c1471a974': `Dokumentum`,
'sa352d168b262aa06': `Lábléc beillesztése`,
'sa37fee6a52d18063': `Dokumentum törlése`,
'sa39c7ac1d37f3bce': `Jelölje meg a kijelölést "kétirányú elszigetelésként".`,
'sa3b4c01623211544': `Erő`,
'sa40fd43756fa8913': `Perzsa`,
'sa417644bef21a9aa': `Névtelen téma`,
'sa43800e28be1bdbc': `Dekoráció színe`,
'sa477cb1825dceb3b': `Szudáni`,
'sa492a51a707930fa': `Blokkidézet beillesztése`,
'sa4e5b39489ecf31a': `Xhosa`,
'sa4f137f8619093a5': `Felirat alul`,
'sa50d3c35533f1d99': `Minden mező`,
'sa53c5cb03a8fda50': `A kijelölést a palettán mint részletet rögzítheti.`,
'sa557ae6bee9148a6': `Progress`,
'sa589e1df65dde0ec': `A kiválasztott elemek méretének, kitöltésének és margóinak beállítása`,
'sa5c371b4bb75e590': `Balra`,
'sa5c80e623459ffe4': `Fejléc beillesztése`,
'sa5df1bcdba46c3fb': `Ábra Felirat`,
'sa602e3fd3f2d98fd': `Animáció`,
'sa644d580d8a11e60': `Ruby igazítás`,
'sa645d315510dc09e': `Válassza ki az elérési utat a lemezről`,
'sa65d4ad99f1d8c06': `Szövegháttér beállítása`,
'sa6607436f60ccc1a': `Észt`,
'sa6f8d27bca557059': `A meta/link/style elemek fel/le mozgatása ebbe az elembe`,
'sa757645ad842da97': `Szünetek megőrzése`,
'sa75b95980cd80e78': `Szerkesztő`,
'sa7698b3d20a6d1ec': `Görgetés`,
'sa778acc33947c7b8': `Befejezni a túrát`,
'sa78a67272a4a6f95': `Matematikai képlet`,
'sa79167651dce1e80': `Alternatív szöveg`,
'sa7af797a46c7d09a': `Táblázat lábléc`,
'sa7dbe35b758c138d': `Vászon beillesztése`,
'sa7dc6b8ef3f595dc': `Forrás beillesztése`,
'sa8279f8211b3950d': `Szünetek és terek megőrzése`,
'sa8b55cab62e439b5': `Oszlop eltávolítása`,
'sa8bbe0197d31b423': `Rövid leírás`,
'sa9ff3b762365abe6': `Transzformáció origó (z)`,
'saa02e3762368ff35': `Transzformáció origó (y)`,
'saa065776236bfa28': `Transzformáció origó (x)`,
'saa33768e03c45fc8': `Fájl mérete`,
'saaad98061a20ac39': `Matematikai képlet beillesztése`,
'saab875d8cfcfe712': `Téma`,
'saad4380b9cc6cefd': `Alternate over`,
'saaec15c97a9e4245': `Oszlop fordított`,
'sab0c57df694a0a09': `Trimmelés indítása`,
'sab4d9283896d9422': `Snap felbontású pixelek`,
'sab55faae8e165407': `Padding&lt;br&gt; mint rés`,
'sab5e7d2a069a2951': `Szakmai bizonyítvány.`,
'sab726d2db7e6b93d': `Kirundi`,
'sac687b8649989de8': `Igazítsa jobbra`,
'sac895c732f350ac5': `Sötét`,
'saced41ddda8b2354': `Flex alapon`,
'sad190f86451081c0': `Nepáli`,
'sad6be321164d08c8': `Kompakt matematika`,
'sadd352cc7f6f2307': `Mellékesen`,
'sae098810f946ca7c': `Tagalog`,
'sae185e6af80ec81e': `Svéd`,
'sae1c7f13b7c0c47f': `Indítsa el a  oldalt.`,
'sae76e25497dcee58': `Recto`,
'sae9c790b88be7eb9': `Maori`,
'sae9d739068eee2c5': `Tatár`,
'saf312eaeec77a802': `Leírás lista (szójegyzék, terminuslista) beillesztése`,
'saf3da7c95cb17260': `Jelölje meg a kiválasztást feliratosként`,
'saf440a0a592f2835': `Frissítés a`,
'saf9e5134ba1a7d30': `Görgetés pattintás`,
'safc6f203342d09e2': `Az aktív dokumentum előnézetének bekapcsolása`,
'sb0a7e3adf4a125ee': `Jobbra fent`,
'sb0a974028c99ca6d': `Engedélyezi az alkalmazkodást?`,
'sb0d4f0f7993cf085': `Betűméret beállítása`,
'sb0f3327210fe18fc': `Oszlopok`,
'sb0f93c1c60c0249a': `Rubin alap`,
'sb1494c08c8c720d1': `Szöveg színének beállítása`,
'sb19611adbc88f711': `Haladó: Forrásszerkesztési parancsok megjelenítése, pl. a dokumentum HTML-jének megjelenítése vagy egyéni stílusok és szkriptek hozzáadása.`,
'sb206d700d26b14ff': `Aláhúzás`,
'sb233557012dcb328': `Mozgás lefelé`,
'sb26035b596566abf': `Névtelen`,
'sb2cda80610c8d6ea': `Space minden`,
'sb2dc787b0983ebc6': `Litvánia`,
'sb31cdff08b1c5a50': `Sindhi`,
'sb38d497d992ab4a4': `Központ`,
'sb3ba3276ae93627c': `Előre formázott szövegblokk beszúrása`,
'sb430f5b4824de0d3': `Válasszon elrendezést`,
'sb43db07b24da018a': `Amharic`,
'sb45f9fb4dba6e71a': `Unset`,
'sb4e003a459464d85': `Kurd`,
'sb4f0310e6787d098': `Üzbég`,
'sb4f1dffbb6be6302': `Tiszta`,
'sb51270e19988f9bd': `Régió`,
'sb59d621e3c93cc27': `Közös cellahatárok`,
'sb5e9e1776242b028': `Kölcsönhatások`,
'sb60bc1250aad44c1': `Span`,
'sb60dd9d23d31ee66': `Doktori fokozat`,
'sb6103872073d369e': `Részletek beillesztése`,
'sb616811735bfbafd': `Táblázat cellája`,
'sb628960829e223bb': `Minden átfedés kihagyása`,
'sb6434faf698b02a2': `Shona`,
'sb657bfe93338dc8b': `Volapuk`,
'sb66beca1e766dcb3': `Alkalmazás és importálás`,
'sb66e2181a7b5738a': `A telemetria engedélyezésével Ön engedélyezi az adatgyűjtést és adatmegőrzést a mi`,
'sb67e0e7c0869f982': `Különbség`,
'sb68e83cda6c85af8': `Asztalfejléc`,
'sb6b268120592dc53': `Hindi`,
'sb6ca0a8bb3caae69': `Díszítés vastagsága`,
'sb70c17f7899f9b01': `Latin`,
'sb71941f552f3504d': `Speciális érték beállítása`,
'sb740eab4afd5a710': `Rács automatikus áramlás`,
'sb741b6e0ca589122': `Visszavont réteg`,
'sb7c77d0415de05cf': `Tesztek futtatása`,
'sb7fb7568f6883ab8': `Az aktív dokumentum megosztása`,
'sb85774dc5d18ff0f': `Megerősítés`,
'sb85b1e36579852a6': `Érvénytelen e-mail vagy jelszó`,
'sb884fa76bfc55429': `Arabic`,
'sb8a3d4df7d1c5e6b': `Egyensúly`,
'sb8f610a0e8df91fc': `Fényerősség`,
'sb8f855b49234b81b': `Alkalmazás`,
'sb905da066c10182c': `Plusz sötétebb`,
'sb940ade1bd81be7e': `A baloldal alatt`,
'sb9e9a7dd45966756': `Jelölje meg a kiválasztást félkövérrel`,
'sba509fd8ed61d1d5': `Nem mentett fájl`,
'sba64d8954d027206': `Opacitás`,
'sba88d90cd6c751b3': `Oszlop szabály`,
'sbaf0a7c417e388af': `Egészség`,
'sbb15d427ee1aa676': `Tigrinya`,
'sbb34f2e3aa40af4e': `Tonga`,
'sbb55f9f2d69fd327': `Háttérszűrő`,
'sbb85a407d730e13d': `Keresés beillesztése`,
'sbb86c6c96f598bb8': `Vegyes`,
'sbba0156f795d8c07': `Kijelölés szerkesztése`,
'sbba865d4b437944f': `Attribútum`,
'sbbe639e3a3ed95d1': `NoScript`,
'sbc5bb5bb74d141b9': `A eltávolítása`,
'sbc5f2a81604baf9b': `6. fejezet`,
'sbc5f2b81604bb14e': `Az 5. fejezet`,
'sbc5f2c81604bb301': `4. fejezet`,
'sbc5f2d81604bb4b4': `3. fejezet`,
'sbc5f2e81604bb667': `2. fejezet`,
'sbc6953a36ced943f': `adatvédelmi politika`,
'sbd181cd54b8402a4': `A kiválasztás szerkesztése`,
'sbd35ee879d9cf770': `Ruby szöveg`,
'sbd40f40cbadd38d5': `Távolítsa el ezt a widget csomagot`,
'sbd72dc858de95ce8': `Burmai`,
'sbe3c60c65f129daa': `Bölcsészettudományok`,
'sbe4a7c8f231739b3': `vagy beillesztés/elhagyás/kiválasztás`,
'sbe90de083557ef3e': `Szuahéli`,
'sbefb6064cba01844': `Zárójel beillesztése`,
'sbf00e1ee999ea94e': `Szkript beillesztése`,
'sbf519920c2017d67': `Lógó`,
'sbfa01f189a68d3e9': `Rugalmas növekedés`,
'sbff54e740c4086eb': `Ismeretlen csomagok megjelenítése`,
'sbfff51feacf30196': `Szanszkrit`,
'sc0ceaa9843510f67': `Türkmenisztán`,
'sc1611c0558728a2a': `Pozíció`,
'sc1a155cc25899250': `Táblázatsor-csoport`,
'sc1aa1f6051b7102a': `Román`,
'sc1edebeaef92b7bd': `Rögzített táblázat elrendezés`,
'sc1fff4f356dfb2fb': `Átalakítás`,
'sc24bda3c061fddf8': `Kattintható terület`,
'sc252a4e091763606': `Táblázat lábléc beszúrása`,
'sc2536e077514accc': `Görgetés`,
'sc275dd00036d16cb': `Idézetek karakter`,
'sc28864200d2a3799': `QR-kód másolása képként`,
'sc2a24a9dd41a9503': `Dekorációs vonal`,
'sc2b734cca2fa643b': `Pan (lefelé)`,
'sc2e2a0dbf03723b7': `Haladó: Ismeretlen forrásból származó csomagok megjelenítése a csomagkezelőben (Figyelmeztetés: Nem biztonságos lehet)`,
'sc3998b77d72c2932': `Weboldal beillesztése (inline keretként)`,
'sc3ac225273c8316b': `Általános`,
'sc3cfee84dbbf36ae': `Helyi fájl`,
'sc3f09a9b6fa4fbed': `Belül`,
'sc43767deea72e9f3': `Leírás Lista`,
'sc462bbdd36bcba6b': `Referencia doboz`,
'sc4ee3e4ee994dafd': `Ukrán`,
'sc50d09edf9325339': `Párbeszéd`,
'sc52b67794c06a0d3': `Perspektívikus eredet (y)`,
'sc52e8b794c0913d6': `Perspektívikus origó (x)`,
'sc53de149fcaad713': `Szereplők közötti`,
'sc546f489f9c0cced': `Átkapcsolja az aktív dokumentum tesztelési módját.`,
'sc5bcf50d1b578d9f': `Betűtípus funkció beállításai`,
'sc5cb39478b9b7625': `Jelölje meg a kijelölést indexként`,
'sc6415b50ff928294': `Listaelem`,
'sc650ff15b20fe9d3': `Forgatás (z)`,
'sc6578b15b2154365': `Forgatás (x)`,
'sc65aff15b2183e58': `Forgatás (y)`,
'sc6da0f4a7e4d710e': `Betűtípus nyelv felülbírálása`,
'sc74e3567875ce255': `Mind a widget címkéje, mind az NPM csomag neve`,
'sc7eb080b96e244df': `Maláj`,
'sc8ac7ef92b95df3f': `Mozgás (x)`,
'sc8af536e2084ade0': `Paletta`,
'sc8b022f92b992bc2': `Mozgás (y)`,
'sc8b39af92b9c2d81': `Mozgás (z)`,
'sc8d2c7f6c33a2b32': `A kiválasztott elemek szövegstílusának (igazítás, behúzás, távolság stb.) beállítása`,
'sc8fa0e3de389ef1c': `Betűméret beállítása`,
'sc9474bf7a0668d73': `Összefoglaló`,
'sc94e314312a8900c': `Cseh`,
'sc980855a000b76ea': `Alul`,
'sc98b103772de63f4': `Finn`,
'sca7cfe2bef51b2a5': `Gyökér`,
'sca7fed2bef53cb99': `Szerepvállalás`,
'scabe6ecee5e01fd2': `Máltai`,
'scace301a88231cce': `Beágyazás`,
'scbc55f622ec078c1': `Doboz megtekintése`,
'scbe537fc38ff4c13': `Rács automatikus oszlopok`,
'scc1db59d292cbc4c': `szakasz`,
'scc56b218a2689c42': `Örmény`,
'scc5ba32e0de06744': `Sesotho`,
'scd15088c39fe9edf': `Padding Box`,
'scd9cedeb5ece3adb': `Kötőjeles`,
'scdf536b65be39ec5': ` Létrehozás/importálás`,
'sce8a4e3f7c98482d': `Siswati`,
'scec2be75ee985f6c': `Ideográfiai`,
'sceecdd0bb404bc17': `Opciócsoport beillesztése`,
'scf00d48fd5953a03': `Görög`,
'scf932840a69dbb7c': `Portugál`,
'scf932a8577057752': `Lábléc`,
'scf95dcb12a950a5c': `Aymara`,
'scfcb70f2a15eaf14': `Jobbra lent`,
'sd01178c54f648118': `Egyensúly oszlopok`,
'sd03bff50f87f82d4': `Kötőjeles karakter`,
'sd05a155fe09c2866': `Online, amikor a`,
'sd0864ea6cb6ef22e': `Közösség`,
'sd10fdbe6caf9a998': `Vonaltörés`,
'sd121d3b959b7888d': `Optimalizálja a sebességet`,
'sd1a78e667a1a139f': `Jelölje meg a kijelölést beszúrásként`,
'sd1cffad290ea5b3b': `Tartsa meg az összes`,
'sd1f10284eeb17b25': `Fidzsi-szigetek`,
'sd1f44f1a8bc20e67': `E-mail`,
'sd1f81984eeb7c0e8': `Töltse ki a  címet.`,
'sd29dc07235eea0f5': `Idézet`,
'sd2addf69477cd4b4': `Csomag importálása`,
'sd2ed26defc646d47': `Háttér szűrő`,
'sd2ef82b8ea877c6d': `Afrikaans`,
'sd319aae1401f1e19': `Rögzített`,
'sd3a288c1094b8a63': `Oszlop szabályszélesség`,
'sd3c65ef5c380c046': `Beépített`,
'sd3dcb76f7b28adb8': `Lett`,
'sd3eca1e0f4209f6e': `Vágja le az összes`,
'sd3f402df8619ddcd': `Ezek az Önre vonatkozó információk automatikusan hozzáadódnak az új dokumentumokhoz.
          Ezt minden egyes dokumentum esetében megváltoztathatja a metaadat-szerkesztőben.`,
'sd4368b12645d3c0f': `Portál beillesztése`,
'sd452cebf4a0313d1': `Forrásszerkesztési parancsok megjelenítése`,
'sd48cc52117f4d68b': `Olasz`,
'sd52660ee947ca58b': `Táblázat oszlop beszúrása`,
'sd588d17a1b25c220': `Szöveg túlcsordulás`,
'sd5be6f6d85fc0c9b': `Zulu`,
'sd5bf67958b08b4cf': `Felsőoktatás.`,
'sd5cf95145e4d89ca': `Tűzd ki ezt a részletet`,
'sd5fd9d11a92f5b1d': `Balra lent (y)`,
'sd60c9bbc51375635': `Gomb beillesztése`,
'sd66c4767fa3dde28': `Akcentus szín`,
'sd679c8b1bf8cc8a5': `Kis tőkesúlyúak`,
'sd7086c4425c53c80': `Betűcsalád`,
'sd837f42ac7cbfb58': `Alak (kívül)`,
'sd88076d2994ee0fb': `Kizárás`,
'sd89a2e529b31ef43': `Vissza`,
'sd8a345e95668b73b': `Függőleges, jobbról balra`,
'sd8ce9e57270b030d': `Font stretch`,
'sd8ecf227c7c49331': `Matematikai`,
'sd8f923198e0c5c6a': `Vége`,
'sd9c21e5f60d6bdd8': `Dán`,
'sd9ff8e2612e63d50': `Határoló doboz méretezése`,
'sda2d76b976502a8d': `Nyisd ki...`,
'sda344aacb837387e': `Helyzet a tartályban`,
'sda5b6fa8b771f996': `Úszás balra`,
'sda9254d1f1228e1a': `Magyar`,
'sdb1595f5c742dfbb': `Bemenet`,
'sdb711380a28fec75': `Lista beillesztése (rendezett)`,
'sdb73788b3c975f16': `Auto`,
'sdbee7e0523a23a42': `Jobbra lent (y)`,
'sdc48456f9a27ae02': `Generátor`,
'sdc70d81cf6c28533': `Grúz`,
'sdd1ff479d04ac140': `Nyilvános`,
'sdd2fc8919a9c3111': `Háttér keverési mód`,
'sdd35b688281b6dea': `Japán`,
'sddc49047f66a64ab': `Nincs leírás megadva`,
'sdef34fe08bb28b09': `Kínai (egyszerűsített)`,
'sdf62e305e1594805': `A kijelölés megjelölése ruby megjegyzéssel`,
'sdf946172dfa0328f': `Felirat:`,
'sdf9bc5d9b7f3e3de': `Kiegyenlítés`,
'se036b53f145441cd': `Vegyes tartalom`,
'se06f459fccdc3ce9': `Utolsó szövegsor igazítása`,
'se0a782a8be8e018b': `Norvég`,
'se0cda6b80a1bb50f': `Szlovák`,
'se0f67eae944f8f94': `Mute`,
'se1312d6528f9a259': `Yoruba`,
'se16c5e66886fbc59': `Cikk`,
'se1f5bb0386c88f96': `A kijelölt szöveg színének beállítása`,
'se219da7b1e955c65': `Egyértelmű formázás`,
'se25e4f2cb77b8be8': `A WebWriter felület és az új dokumentumok nyelvezete`,
'se2796c5824ec8916': `Tartalom láthatósága`,
'se308836a594808b6': `Singhalese`,
'se36c5b1baf5e0660': `Bárhol`,
'se39c065efa467782': `Baszk`,
'se3b4c857f91f80d7': `Billentyűzet gyorsbillentyűk`,
'se47baf2fd16b9d2b': `Sablon`,
'se48bd9e6c2a3109d': `Számlák`,
'se58467472725ad0c': `Képfelbontás`,
'se58f06c2b0583ff7': `Koordináták kiválasztása`,
'se5dc1e97fb743ade': `Távolságtartás`,
'se619a501d1bfe6a5': `Wrap`,
'se62385ac082368d2': `Jelölje meg a kiválasztást idézési forrásként`,
'se6297163cac9d276': `Forrás szerkesztése`,
'se633223a0b88625e': `Cellák elhelyezése`,
'se638417c560cfe5c': `Betörés belülről`,
'se64f418b4e733b6c': `Kimenet beszúrása`,
'se6cdad455e2d8c02': `Osztás beillesztése`,
'se79c0a3ac70d8fb3': `Asp. arány (x)`,
'se79fae3ac710dc36': `Asp. arány (y)`,
'se7fad370d8fb4cec': `Olvashatóság optimalizálása`,
'se8a94b4effa2033e': `Betűrendes`,
'se95d4e55ea186d9a': `Görgetősáv színe`,
'se96d43a515b8451c': `Szlovén`,
'se96fd76ba1b2975a': `Központi`,
'se9ac05f36b004eb0': `Rejtse el a bevezető túrát. Letiltás, így a túra ismét megjelenik.`,
'se9b1fec72ffd8f48': `Helyi`,
'sea24bdcaa2bd2dec': `Kötelező csettintés`,
'sea52df2b70a5c10d': `Ruby`,
'sea6e7291e27ec53f': `A metaadatok szerkesztőjének bekapcsolása`,
'sea896ed51ad33287': `Nincsenek specifikus stílusok`,
'seaaaeb09e3b4e78b': `Szerkesztési parancsok`,
'seabae79729c4b2ad': `Toggle email`,
'seaecc8267bad6234': `Középiskola`,
'seaf97719986faf4f': `Gap`,
'seb19675a580f0628': `Kerülje az oszlopot`,
'seb4e52ef5ec7a7dc': `Színek/Effektek`,
'seb8982ae8c3cdcc5': `Indonéz`,
'sebbced89e0db2894': `Első alapérték`,
'sec02109a0dd2a6c8': `Kiemelés szín`,
'sec2557a35b702525': `Változó`,
'sec2da4aa7a02b925': `Izlandi`,
'sec30fbb20f102670': `Összefoglaló beillesztése`,
'sec8b0b6c729816b6': `Fejezeti csoport`,
'seccd05955adb76bc': `Plakát`,
'sed17285cd25d6389': `A package.json könyvtár, ahol a package.json található`,
'sed318ec045c5144f': `Vége`,
'sed713f1b916fb469': `Határtávolság (x)`,
'sed74a31b9172942c': `Határtávolság (y)`,
'sed86bd0deb2e5372': `Szöveg átalakítása`,
'see2fcaedf9743ec6': `Helyszín`,
'seec6798afe90ffc8': `Nyomtatás`,
'sef00c258bc1ecf1e': `Ez a felfedezhető nem mentett változásokkal rendelkezik.`,
'sef23dd271edd4a8b': `Balra lent`,
'sef24caccbd4645ef': `Rugalmas zsugorodás`,
'sef49aec68fd1dc66': `Név`,
'sef73fe18e351eb35': `Kulcsszavak`,
'sef75f458d77491af': `Opciós csoport`,
'sefcf950b3cc4fc3b': `Nyelv`,
'sf0c8e2b013e5ff18': `Bhutani`,
'sf0ca10f343249063': `Tartalom`,
'sf0cab2483f66aa2e': `Custom`,
'sf0e261e04eda82ff': `Megjelenés`,
'sf1045382c1fd9a85': `Pontos nyomtatási színek`,
'sf14c35392ec7bf10': `Ez a funkció nem érhető el a Firefoxban. A Chrome-ban vagy az Edge-ben elérhető.`,
'sf14f9d5f9f6ca342': `Plusz könnyebb`,
'sf1868dc19e3917bb': `Spanyol`,
'sf190149f9d8bbb2a': `Írásmód`,
'sf1e79171c4856543': `Biztos vagy benne? Ezt a műveletet nem lehet visszafordítani, minden beállítása
          törlődik és visszaáll.`,
'sf21c1f60c7515f44': `Jelölje meg a kiválasztást mintakimenetként`,
'sf21fb4f4b9e8911f': `Szélesség`,
'sf22a3737146ec910': `A WebWriter közvetlenül a dokumentumba ágyazhatja az SVG-t.`,
'sf2514d5dc78b1654': `Widget beillesztése`,
'sf28903d4ca0ddcfc': `Távolítsa el ezt a fiókot`,
'sf2ab37af0abc55ef': `Rejtsd el az intro túrát`,
'sf2bdb0b4d7b9c039': `Bengáli`,
'sf2cbb5e519264e67': `Méretváltoztatás vízszintesen és függőlegesen`,
'sf2d5cbc2fe0ad65a': `Ragadós`,
'sf2d96d0eb32cb81f': `Animációs kompozíció`,
'sf2de3dbe2108637a': `Formarenderelés`,
'sf2e08a945e9194d4': `Welch`,
'sf34696c526e810b4': `Inline`,
'sf39736a666dbb038': `Sáv beillesztése`,
'sf3c4da68b08a2590': `Malagasy`,
'sf471ec2496f904cc': `Változások eldobása`,
'sf4849bc200e279ed': `A táblázat felirata`,
'sf486ca1fdbe08645': `Ábra beillesztése`,
'sf4b537d4cbd8f5fd': `Szöveg tetején`,
'sf4e0e02a5277ef23': `Szövegterület beszúrása`,
'sf4f067d41efd4b83': `Skála (y)`,
'sf4f3cbd41f002b46': `Skála (x)`,
'sf4fa67d41f05a008': `Skála (z)`,
'sf5197db2d5f2926a': `Forgassa el a`,
'sf52d840949a980d1': str`
          ${0}
          véglegesen törlésre kerül. Biztos vagy benne? 
        `,
'sf55d634dcc743595': `Szolgáltatások`,
'sf59c9081d106dd9c': `A kijelölés változóként való megjelölése`,
'sf5e76f774beb33c2': `Inuktitut`,
'sf64a8229a8136552': `Dokumentum törlése`,
'sf65df67a03bebe4b': `Ehhez a widgethez szükséges`,
'sf6673729c03ae999': `WebWriter alaphelyzetbe állítása`,
'sf67571992e7dc88e': `Teljes időtartam`,
'sf6b4934598f7ed10': `Engedélyezze a kiválasztást`,
'sf6e1665c7022a1f8': `Jelszó`,
'sf79e0d78b56444f1': `Inline végződés`,
'sf7a5f7a7c80c3082': `Mindkettő`,
'sf7c0eba7c822e3d6': `Bold`,
'sf86bd4d2982f3b74': `Jelölje meg a kiválasztást kódként`,
'sf8e82313fa411494': `Jelölje meg a kiválasztást hivatkozásként`,
'sf955eff73fb6b573': `Szerb`,
'sf9929e2d356260c5': `Szorozd meg`,
'sf993bb199fefbe04': `Minden`,
'sf9ecf969dd4b8164': `Mindkét él`,
'sf9f2c719a04066ec': `App`,
'sfa49a5bb1a5d353e': `Privát hozzáférés`,
'sfa59c7777e2a0eeb': `Adatlista beszúrása`,
'sfaa0a67db5c11f72': `Az első szövegsor behúzása`,
'sfb231a52211b133f': `Nincs szövegtörlés`,
'sfb68cae41d749423': `Kezdeti`,
'sfb9b6edb0ed378c9': `Hivatkozás Forrás`,
'sfbbab09dbe553571': `Vektoros rajz (SVG) beillesztése`,
'sfc00292e778b67e2': `Meter`,
'sfc63e31ac7c956ed': `Válassza ki a  címet.`,
'sfc815c9078bba30a': `QR-kód letöltése képként`,
'sfcdd8e672c75b713': `Cím:`,
'sfcebd18506f1e535': `Flow`,
'sfd0cde85070d2eb2': `Flex`,
'sfd77270c3f54f664': `Kimenet`,
'sfdb1e4d90981a535': `A dokumentum megosztása`,
'sfdeef3dccf409f81': `Ez a kulcsszó szükséges a widgetekhez`,
'sfe6e758ad2603c1d': `Mesterképzés`,
'sfee1c12daf838935': `Színes égés`,
'sff303daee4dd9f7b': `Lingala`,
'sff3df0c2823ec6e4': `Verso`,
'sff99962304ac7d25': `Párbeszéd beillesztése`,
'sffa395f64ec6ac36': `Bolgár`,
'sffdadf0a576fd802': `Magasság`,
'spaceKey': `Űr`,
'tabKey': `⭾ Tab`,
'upKey': `↑ Fel`,
's2739460e44320108': `Chinese (Traditional)`,
'scbf29ce484222325': ``,
    };
  